module.exports = __webpack_public_path__ + "img/fromParliament.f8a4c70d.jpg";